import React from 'react';
import { IconButton } from '@fluentui/react';

const PageHeader = (props) => {
    let canEdit = props.canEdit;
    let canDelete = props.canDelete;

    if (
        props.page.configureActions !== undefined &&
        props.page.configureActions !== null
    ) {
        canEdit = canEdit && props.page.configureActions.includes('edit');
        canDelete = canDelete && props.page.configureActions.includes('delete');
    }

    return (
        <div className="managerecord-sectiontitle">
            {props.page.pageTitle}
            <span className="formdefinition-menuposition">
                {canEdit && (
                    <IconButton
                        iconProps={{ iconName: 'Edit' }}
                        onClick={() => props.edit(props.page)}
                        styles={{
                            root: { height: '18px', verticalAlign: 'middle' },
                        }}
                    />
                )}
                {canDelete && (
                    <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        onClick={() => props.delete(props.page)}
                        styles={{
                            root: { height: '18px', verticalAlign: 'middle' },
                        }}
                    />
                )}
            </span>
        </div>
    );
};

export default PageHeader;
